// Atlica — theme.js
// Lightweight interactions: FAQ accordion, PDP thumbnail swap, variant selection, quantity, AJAX add-to-cart

document.addEventListener('DOMContentLoaded', () => {
// === Mobile menu toggle ===
const navToggle = document.getElementById('nav-toggle');
const mobileMenu = document.getElementById('mobile-menu');
const mobileMenuClose = document.getElementById('mobile-menu-close');
if (navToggle) navToggle.addEventListener('click', () => { mobileMenu.classList.add('open'); document.body.style.overflow = 'hidden'; });
if (mobileMenuClose) mobileMenuClose.addEventListener('click', () => { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; });
 
// === FAQ accordion ===
  document.querySelectorAll('.faq-q').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.parentElement.classList.toggle('open');
    });
  });

  // === PDP thumbnail swap ===
  document.querySelectorAll('.pdp-thumb').forEach(t => {
    t.addEventListener('click', () => {
      document.querySelectorAll('.pdp-thumb').forEach(x => x.classList.remove('active'));
      t.classList.add('active');
      const src = t.getAttribute('data-src');
      const mainBox = document.getElementById('pdp-image-main');
      if (src && mainBox) {
        mainBox.style.backgroundImage = `url('${src}')`;
      }
    });
  });

  // === Size selector ===
  document.querySelectorAll('.size-opt').forEach(s => {
    s.addEventListener('click', () => {
      if (s.classList.contains('unavailable')) return;
      document.querySelectorAll('.size-opt').forEach(x => x.classList.remove('selected'));
      s.classList.add('selected');
      const input = document.getElementById('selected-variant-id');
      const variantId = s.getAttribute('data-variant-id');
      if (input && variantId) input.value = variantId;
      const radio = s.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    });
  });

  // === Quantity control ===
  document.querySelectorAll('.qty-control').forEach(ctrl => {
    const input = ctrl.querySelector('.qty-value');
    const btns = ctrl.querySelectorAll('.qty-btn');
    if (!input) return;
    btns.forEach((b, i) => {
      b.addEventListener('click', (e) => {
        e.preventDefault();
        let qty = parseInt(input.value) || 1;
        qty = Math.max(1, qty + (i === 0 ? -1 : 1));
        input.value = qty;
      });
    });
  });

  // === Color swatch (single-color but interaction-ready) ===
  document.querySelectorAll('.color-swatch').forEach(s => {
    s.addEventListener('click', () => {
      document.querySelectorAll('.color-swatch').forEach(x => x.classList.remove('selected'));
      s.classList.add('selected');
    });
  });

  // === AJAX add-to-cart ===
  const cartForm = document.getElementById('product-form');
  if (cartForm) {
    cartForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = cartForm.querySelector('.btn-cart');
      const originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      try {
        const formData = new FormData(cartForm);
        const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
        if (!res.ok) throw new Error('Add to cart failed');
        await res.json();
        btn.textContent = 'Added to bag';
        // Update cart count
        const cartRes = await fetch('/cart.js');
        const cart = await cartRes.json();
        const cartCount = document.querySelector('.cart-icon');
        if (cartCount) cartCount.textContent = `Cart [${cart.item_count}]`;
        setTimeout(() => {
          btn.textContent = originalText;
          btn.disabled = false;
          window.location.href = '/cart';
        }, 600);
      } catch (err) {
        btn.textContent = 'Try again';
        btn.disabled = false;
        console.error(err);
      }
    });
  }

  // === Newsletter signup placeholder ===
  document.querySelectorAll('.footer-form').forEach(f => {
    f.addEventListener('submit', (e) => {
      // Shopify handles via /contact form action — fallback for static
      if (!f.action || f.action.indexOf('/contact') === -1) {
        e.preventDefault();
        const input = f.querySelector('input[type=email]');
        const btn = f.querySelector('button');
        if (input && input.value) {
          btn.textContent = 'Thanks';
          input.value = '';
        }
      }
    });
  });

});
